/*
  Indicador de que ainda há conteúdo fora da dobra num trilho que rola na
  vertical. É o irmão vertical do side-scroller (assets/side-scroller.js):
  mesmo desenho de componente, mesmos nomes de estado (can-scroll-*), e o
  gradiente vive no CSS — aqui só medimos.

    <scroll-hint>
      <div class="scrollable-container"> ... </div>
    </scroll-hint>
*/

class ScrollHint extends HTMLElement {
  constructor() {
    super();
    this._resizeObserver = null;
    this._handleScroll = this._handleScroll.bind(this);
  }

  connectedCallback() {
    const container = this.querySelector(".scrollable-container");
    if (!container) return;

    container.addEventListener("scroll", this._handleScroll);
    this._updateScrollState(container);

    // Havendo ou não transbordo só dá para saber medindo, e a medida muda com
    // resize, imagem carregada tarde e conteúdo trocado (aqui, a troca de aba).
    // Sem observar, o gradiente fica congelado no primeiro cálculo.
    if ("ResizeObserver" in window) {
      this._resizeObserver = new ResizeObserver(() =>
        this._updateScrollState(container)
      );
      this._resizeObserver.observe(container);
      Array.from(container.children).forEach((child) =>
        this._resizeObserver.observe(child)
      );
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    const container = this.querySelector(".scrollable-container");
    if (container) container.removeEventListener("scroll", this._handleScroll);
  }

  _updateScrollState(container) {
    const maxTop = Math.max(0, container.scrollHeight - container.clientHeight);
    const scrollOffset = 10;
    this.classList.toggle("can-scroll-up", container.scrollTop > scrollOffset);
    this.classList.toggle(
      "can-scroll-down",
      container.scrollTop < maxTop - scrollOffset
    );
  }

  _handleScroll(e) {
    this._updateScrollState(e.currentTarget);
  }
}

// guard como em bundle-progressbar e tab-nav: o arquivo é global, e redefinir o
// mesmo nome lança e derruba o resto do script.
if (!customElements.get("scroll-hint")) {
  customElements.define("scroll-hint", ScrollHint);
}
